import { ArrowDownIcon, ArrowUpIcon } from '@radix-ui/react-icons';
import { Badge, Separator } from '@radix-ui/themes';
import { MetricHelper } from 'classes/helpers/metric.helper';
import { MachineContext } from 'contexts/machine.context';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ITrajektRefBreak } from 'lib_ts/interfaces/pitches';
import { useContext } from 'react';

export const CommonVerticalBreaksBadge = (props: {
  breaks: ITrajektRefBreak;
}) => {
  const { machine, unitFactors } = useContext(MachineContext);

  const breaksIn = props.breaks.zInches;
  const breaksDown = breaksIn < 0;

  const icon = breaksDown ? <ArrowDownIcon /> : <ArrowUpIcon />;
  const title = breaksDown ? 'Breaks down' : 'Breaks up';

  const valueDisplay = breaksIn * unitFactors.fromBreaksIn;
  const unitsDisplay = MetricHelper.getBreaksUnit(machine.isMetric, true);

  return (
    <Badge color={RADIX.COLOR.NEUTRAL} title={title}>
      {valueDisplay.toFixed(0)}
      <span className="BadgeUnits">{unitsDisplay}</span>
      <Separator orientation="vertical" style={{ height: '11px' }} />
      {icon}
    </Badge>
  );
};
